var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5H22C24.4853 0.5 26.5 2.51472 26.5 5V22C26.5 24.4853 24.4853 26.5 22 26.5H5C2.51472 26.5 0.5 24.4853 0.5 22V5C0.5 2.51472 2.51472 0.5 5 0.5Z",
    stroke: "#004EFF",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 12.1875H14.3125V7.3125C14.3125 6.86377 13.9487 6.5 13.5 6.5C13.0513 6.5 12.6875 6.86377 12.6875 7.3125V12.1875H7.8125C7.36377 12.1875 7 12.5513 7 13C7 13.4487 7.36377 13.8125 7.8125 13.8125H12.6875V18.6875C12.6875 19.1362 13.0513 19.5 13.5 19.5C13.9487 19.5 14.3125 19.1362 14.3125 18.6875V13.8125H19.1875C19.6362 13.8125 20 13.4487 20 13C20 12.5513 19.6362 12.1875 19.1875 12.1875Z",
    fill: "#004EFF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItems);
export default __webpack_public_path__ + "static/media/AddItems.3ad3d6991f21f6c4477cab678995f7b2.svg";
export { ForwardRef as ReactComponent };